var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMc00(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m7.69,28.6,20.72-12.75v1.4s0,11.35,0,11.35H6.36s0,.7,0,.7c0,.39.3.7.67.7h22.05c.37,0,.67-.31.67-.7v-12.75c0-.39-.3-.7-.67-.7h-.67"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m3.82,15.49h4.06c.37,0,.67.3.67.67s-.3.67-.67.67H3.82c-.37,0-.67-.3-.67-.67s.3-.67.67-.67Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m16.02,16.83h1.36v1.36c0,.37.3.67.67.67s.67-.3.67-.67v-1.36h1.36c.37,0,.67-.3.67-.67s-.3-.67-.67-.67h-1.36v-1.36c0-.37-.3-.67-.67-.67s-.67.3-.67.67v1.36h-1.36c-.37,0-.67.3-.67.67s.3.67.67.67Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m22.98,9.75h-1.91v-2.24c0-.37-.3-.67-.67-.67h-2.03c-.37,0-.67.3-.67.67v2.24h-3.91v1.4h8.53v11.35H1.59v-11.35h8.53v-1.4h-3.91v-2.24c0-.37-.3-.67-.67-.67h-2.03c-.37,0-.67.3-.67.67v2.24H.92c-.37,0-.67.31-.67.7v12.75c0,.39.3.7.67.7h22.05c.37,0,.67-.31.67-.7v-12.75c0-.39-.3-.7-.67-.7Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m4.64,25.55,20.72-12.75v1.4s0,11.35,0,11.35H3.31s0,.7,0,.7c0,.39.3.7.67.7h22.05c.37,0,.67-.31.67-.7v-12.75c0-.39-.3-.7-.67-.7h-.67"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m14.63,5.6c.39,0,.72-.34.72-.76s-.32-.76-.72-.76h-1.92v-.88h1.92c.39,0,.72-.34.72-.76s-.32-.76-.72-.76h-1.92v-.98c0-.39-.34-.72-.76-.72s-.76.32-.76.72v10.44c-.62.29-1.05.91-1.05,1.64,0,1,.81,1.81,1.81,1.81s1.81-.81,1.81-1.81c0-.73-.43-1.35-1.05-1.64v-3.17h1.92c.39,0,.72-.34.72-.76s-.32-.76-.72-.76h-1.92v-.88h1.92Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMc00);
export default __webpack_public_path__ + "static/media/MC00.5439d4fdd55755ed714d80900f58cf57.svg";
export { ForwardRef as ReactComponent };